import createReactComponent from '../createReactComponent';
export default createReactComponent('corner-down-right', 'CornerDownRight', [["path",{"d":"M19 13.973H9a4 4 0 0 1-4-4V5m9.22 14L19 13.973l-4.78-5.027","key":"svg-0"}]]);